var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bespread-wrap module-layer4"},[_c('div',{staticClass:"screen-container"},[_c('div',{staticClass:"cnt"},[_c('div',{staticClass:"layer-box-cnt"},_vm._l((_vm.boxList),function(pItem){return _c('div',{key:pItem.id,staticClass:"pic-num",class:[
            'pic' + pItem.id,
            _vm.boxIndex == pItem.id ? 'box-active' : 'box-unactive'
          ]},[(_vm.boxIndex != pItem.id)?_c('div',{staticClass:"pic-box",class:'pic-box' + pItem.id,on:{"click":function($event){return _vm.handlePic(pItem)},"mouseenter":function($event){return _vm.handlePicMouse(pItem)},"mouseleave":function($event){return _vm.handlePicLeave(pItem)}}},[_c('img',{staticClass:"sl-cnt",attrs:{"src":_vm.mouseIdx == pItem.id
                  ? require('../../assets/img/layer4/' +
                      _vm.lang +
                      '/pic-cnt-active-' +
                      pItem.id +
                      '.png')
                  : require('../../assets/img/layer4/' +
                      _vm.lang +
                      '/pic-cnt-' +
                      pItem.id +
                      '.png')}}),_vm._v(" "),_c('div',{staticClass:"sl_car"})]):_vm._e(),_vm._v(" "),(_vm.boxIndex == pItem.id)?_c('div',{staticClass:"sl-box",class:['sl-box' + pItem.id]},[_c('img',{staticClass:"sl-title",attrs:{"src":require('../../assets/img/layer4/' +
                  _vm.lang +
                  '/pic-title-' +
                  pItem.id +
                  '.png')}})]):_vm._e()])}),0),_vm._v(" "),_c('div',{staticClass:"layer-line-cnt"},[_c('div',{staticClass:"botton-icon"},_vm._l((_vm.navList),function(item,idx){return _c('div',{key:idx,staticClass:"icon",on:{"click":function($event){return _vm.handleIcon(item)}}},[_c('img',{attrs:{"src":_vm.iconIndex == item.id 
            ? require('../../assets/img/layer4/' +
                      _vm.lang +
                      '/menu-' +
                      item.id +
                      '-active.png')
                  : require('../../assets/img/layer4/' +
                      _vm.lang +
                      '/menu-' +
                      item.id +
                      '.png')}})])}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92b336f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/publicComponents/layer4.vue
// module id = null
// module chunks = 